export default __webpack_public_path__ + "static/media/slide5.7d1e0c8e.jpg";